export default __webpack_public_path__ + "static/media/more.9d4afa67.svg";